import React from "react";
import FileDropZone from "../FileDropZone.js";
import CustomLabel from "../CustomLabel.js";
import { FormattedMessage, injectIntl } from "react-intl";
import { Modal } from "react-bootstrap";
import FileUtil from "../../../util/FileUtil.js";
import Icon from "../Icon.js";
import MenuButton from "../bootstrap/MenuButton";

class ImportExcelFileModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      file: null,
      isFormVisible: true,
      isProgressBarVisible: false,
    };
  }

  // Download dynamically generated Excel template from backend
  downloadTemplate() {
    return FileUtil.dowloadFileHack(
      this.props.templateFileUrl,
      this.props.templateFileName,
      "xlsx",
    );
  }

  onDropFile(file) {
    this.setState({ file: file });
  }

  onComplete() {
    this.setState({
      disabled: true,
      isFormVisible: false,
      isProgressBarVisible: true,
    });

    this.props.onComplete(this.state.file);
  }

  disableButton() {
    return !this.state.file;
  }

  render() {
    const { closeModal, intl, title } = this.props;
    return (
      <Modal
        show={true}
        onHide={() => closeModal()}
        backdrop={"static"}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4 className="mb-5 w-100 text-center ">
            <FormattedMessage id="Step.1" />
          </h4>

          {this.state.isProgressBarVisible && (
            <div className={"text-center mb-5 "}>
              <Icon
                icon="gear"
                size="3x"
                className="fa-spin text-success mb-3"
              />
              <div className="progress" style={{ height: "30px" }}>
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: "100%" }}
                >
                  <strong>
                    <FormattedMessage id="Import.In.Progress" />
                  </strong>
                </div>
              </div>
            </div>
          )}

          {this.state.isFormVisible && (
            <div>
              <CustomLabel
                label={intl.formatMessage({ id: "Import.File" })}
                htmlFor="name"
                displayAsCol
                required
              />
              <FileDropZone
                onDropFile={(file) => this.onDropFile(file)}
                acceptedExtensions={["xls", "xlsx"]}
                multiple={false}
              />

              <div className="text-center">
                <MenuButton
                  className="text-center mt-3"
                  onClick={() => this.downloadTemplate()}
                >
                  <Icon icon="file-excel" className="me-2" />
                  <FormattedMessage id="Download.Template" />
                </MenuButton>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <MenuButton variant="secondary" onClick={() => closeModal()}>
            <FormattedMessage id="Cancel" />
          </MenuButton>
          <MenuButton
            onClick={() => this.onComplete()}
            disabled={this.disableButton()}
          >
            <FormattedMessage
              id={!this.state.isProgressBarVisible ? "Step.2" : "Plz.Wait"}
            />
          </MenuButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(ImportExcelFileModal);
